var map = {
	"./1024.png": 6886,
	"./128.png": 4768,
	"./16.png": 3334,
	"./2.png": 7217,
	"./2048.png": 2825,
	"./2048title.png": 3811,
	"./256.png": 1116,
	"./32.png": 9512,
	"./4.png": 8727,
	"./4096.png": 4882,
	"./512.png": 1795,
	"./64.png": 1045,
	"./8.png": 107,
	"./comingsoon.png": 5019,
	"./diamond.png": 519,
	"./diamond2.png": 2117,
	"./game-over.png": 3654,
	"./goldenCoin.png": 9543,
	"./grape.png": 7338,
	"./grapecell.png": 3198,
	"./impact.png": 5605,
	"./jump1-1.png": 5444,
	"./jump1-2.png": 95,
	"./jump1-3.png": 3766,
	"./jump1-4.png": 3593,
	"./jump1-5.png": 8768,
	"./jump2 (2).png": 2146,
	"./jump2 - 복사본.png": 4785,
	"./jump2.png": 3381,
	"./jump3-2.png": 2441,
	"./jump3.png": 7468,
	"./jumpjump.png": 6499,
	"./jumpplayerlose.png": 5455,
	"./pixil-frame-0.png": 4836,
	"./pixil-frame-1.png": 2317,
	"./pixil-frame-2.png": 1078,
	"./pixil-frame-3.png": 2476,
	"./pixil-frame-4.png": 7248,
	"./pixil-frame-5.png": 4153,
	"./selectedgrapecell.png": 6075,
	"./speedmath.png": 9684,
	"./sudoku.png": 1436,
	"./try-again.png": 4115,
	"./wordle.png": 6362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;